import { ButtonVariant, CoButton } from "components/CoButton";
import MeterTag from "components/Tag/tags/MeterTag";
import { METER_INDICATORS_BLOG_URL } from "constants/config";
import useLabels from "hooks/useLabels";
import { YesNoType } from "types/YesNoType";

/**
 * @component MeterIndicatorTooltip
 * @description Tooltip for meter indicators
 * @example
 * return (
 *   <MeterIndicatorTooltip />
 * )
 */

type MeterIndicatorTooltipProps = {
  meter?: YesNoType;
  query?: string;
};

const MeterIndicatorTooltip = (props: MeterIndicatorTooltipProps) => {
  const [pageLabels] = useLabels("tooltips.meter-indicators");
  const [meterLabels] = useLabels("meter");

  const meterLabel = meterLabels[props.meter || "YES"];

  return (
    <div className="w-60">
      <div className="flex flex-col gap-3 text-left">
        <div className="w-auto flex">
          <MeterTag meter={props.meter} />
        </div>
        <section>
          <h3 className="sm-md text-fg-base">{pageLabels["your-question"]}:</h3>
          <p className="sm-normal text-fg-base">"{props.query}"</p>
        </section>
        <section>
          <h3 className="sm-md text-fg-base">{pageLabels["prediction"]}:</h3>
          <p className="sm-normal text-fg-base">
            {props.meter === "UNKNOWN" ? (
              pageLabels["unknown-paper-leans"]
            ) : (
              <>
                <span>{pageLabels["paper-leans"]}</span>
                <span> "{meterLabel}"</span>
              </>
            )}
          </p>
        </section>
        {props.meter !== "UNKNOWN" ? (
          <CoButton
            onClick={(e) => {
              window.open(METER_INDICATORS_BLOG_URL, "_blank");
              e.preventDefault();
            }}
            label="Learn more"
            size="sm"
            iconRight="icon-external-link"
            variant={ButtonVariant.Tertiary}
          />
        ) : null}
      </div>
    </div>
  );
};

export default MeterIndicatorTooltip;
